var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"sceneAbsolute form-control input-scene addQTip",class:[
        _vm.isValid === true ? 'isValid' : '',
        _vm.isValid === false ? 'isInvalid' : '',
        _vm.numberingFrom === 'custom' ? 'isCustom' : ''
    ],staticStyle:{"padding":"0","text-align":"center","max-width":"60px"},attrs:{"type":"text","placeholder":_vm.sceneAbsolute,"size":"6","maxlength":"8","title":"Change this value if scene absolute numbering differs from the indexer absolute numbering. Generally used for anime shows."},domProps:{"value":_vm.sceneAbsolute},on:{"change":_vm.changeSceneNumbering}})
}
var staticRenderFns = []

export { render, staticRenderFns }